const GameEventColor = {
  missionpass: '#F4A900',
  collectobject: '#025669',
  tournament: '#FF5733',
  tournamentV2: '#C70039',
  spacemission: '#900C3F',
  crazydeal: '#581845',
  endlessoffer: '#DAF7A6',
  thunderrace: '#FFC300',
  magicalchest: '#FF5733',
  magiccauldron: '#00c767ff',
};

const PRIMARY_COLOR = '#377DFF';
const ALERT_COLOR = '#FF4D4F';

export { GameEventColor, PRIMARY_COLOR, ALERT_COLOR };
